"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("@/room/settlement_request/settlementRequestDataState"));
const react_i18next_1 = require("react-i18next");
const SellerPublishAgreeDialog_1 = __importDefault(require("@/common/components/SellerPublishAgreeDialog"));
const material_ui_confirm_1 = require("material-ui-confirm");
const settlement_request_1 = require("@/room/settlement_request");
const _1 = require(".");
function default_1({ open, closeDialog, checkSettlementRequest, openCompanyRegisterDialog, setValue, }) {
    const [settlementRequestData, setSettlementRequestData] = (0, recoil_1.useRecoilState)(settlementRequestDataState_1.default);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onSellerPublishAgreeSuccess = () => {
        setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { channel_company_seller_publish_agree: true })));
        checkSettlementRequest();
    };
    const onSellerPublishAgreeError = {
        alreadyAgree: () => {
            setSettlementRequestData(prev => (Object.assign(Object.assign({}, prev), { channel_company_seller_publish_agree: true })));
            confirm({
                description: t('이미 판매 페이지 하단, 사업자 정보 게시를 확인하였어요'),
                cancellationButtonProps: { style: { display: 'none' } },
            });
        },
        requireCompany: () => {
            (0, settlement_request_1.invalidateSettlementCompanyData)({ setSettlementRequestData, setValue });
            (0, _1.companyInfoErrorConfirm)({ confirm, openCompanyRegisterDialog });
        },
    };
    return ((0, jsx_runtime_1.jsx)(SellerPublishAgreeDialog_1.default, { open: open, closeDialog: closeDialog, company_name: settlementRequestData.company_name, company_number: settlementRequestData.company_number, onSellerPublishAgree: { onSellerPublishAgreeSuccess, onSellerPublishAgreeError } }));
}
exports.default = default_1;
